// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/store_config/v1/store_config.proto (package fingertip.creator.store_config.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { GetAccountSessionRequest, GetAccountSessionResponse, GetStoreConfigPublicRequest, GetStoreConfigPublicResponse, GetStoreConfigRequest, GetStoreConfigResponse, GetStripeConnectedAccountLinkRequest, GetStripeConnectedAccountLinkResponse, GetStripeConnectedAccountRequest, GetStripeConnectedAccountResponse, UnlinkStripeConnectedAccountRequest, UnlinkStripeConnectedAccountResponse, UpsertStoreConfigRequest, UpsertStoreConfigResponse } from "./store_config_pb.js";

/**
 * @generated from rpc fingertip.creator.store_config.v1.StoreConfigService.GetStripeConnectedAccount
 */
export const getStripeConnectedAccount = {
  localName: "getStripeConnectedAccount",
  name: "GetStripeConnectedAccount",
  kind: MethodKind.Unary,
  I: GetStripeConnectedAccountRequest,
  O: GetStripeConnectedAccountResponse,
  service: {
    typeName: "fingertip.creator.store_config.v1.StoreConfigService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_config.v1.StoreConfigService.GetStripeConnectedAccountLink
 */
export const getStripeConnectedAccountLink = {
  localName: "getStripeConnectedAccountLink",
  name: "GetStripeConnectedAccountLink",
  kind: MethodKind.Unary,
  I: GetStripeConnectedAccountLinkRequest,
  O: GetStripeConnectedAccountLinkResponse,
  service: {
    typeName: "fingertip.creator.store_config.v1.StoreConfigService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_config.v1.StoreConfigService.GetStoreConfig
 */
export const getStoreConfig = {
  localName: "getStoreConfig",
  name: "GetStoreConfig",
  kind: MethodKind.Unary,
  I: GetStoreConfigRequest,
  O: GetStoreConfigResponse,
  service: {
    typeName: "fingertip.creator.store_config.v1.StoreConfigService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_config.v1.StoreConfigService.GetStoreConfigPublic
 */
export const getStoreConfigPublic = {
  localName: "getStoreConfigPublic",
  name: "GetStoreConfigPublic",
  kind: MethodKind.Unary,
  I: GetStoreConfigPublicRequest,
  O: GetStoreConfigPublicResponse,
  service: {
    typeName: "fingertip.creator.store_config.v1.StoreConfigService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_config.v1.StoreConfigService.UpsertStoreConfig
 */
export const upsertStoreConfig = {
  localName: "upsertStoreConfig",
  name: "UpsertStoreConfig",
  kind: MethodKind.Unary,
  I: UpsertStoreConfigRequest,
  O: UpsertStoreConfigResponse,
  service: {
    typeName: "fingertip.creator.store_config.v1.StoreConfigService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_config.v1.StoreConfigService.UnlinkStripeConnectedAccount
 */
export const unlinkStripeConnectedAccount = {
  localName: "unlinkStripeConnectedAccount",
  name: "UnlinkStripeConnectedAccount",
  kind: MethodKind.Unary,
  I: UnlinkStripeConnectedAccountRequest,
  O: UnlinkStripeConnectedAccountResponse,
  service: {
    typeName: "fingertip.creator.store_config.v1.StoreConfigService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_config.v1.StoreConfigService.GetAccountSession
 */
export const getAccountSession = {
  localName: "getAccountSession",
  name: "GetAccountSession",
  kind: MethodKind.Unary,
  I: GetAccountSessionRequest,
  O: GetAccountSessionResponse,
  service: {
    typeName: "fingertip.creator.store_config.v1.StoreConfigService"
  }
};
